import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { ProductCard } from '..';
var CleanCheckoutProductCard = function (props) { return (React.createElement("div", { className: props.className },
    React.createElement(ProductCard, { className: 'item-checkout', imageToRight: true, product: __assign(__assign({}, props.checkoutProductStore), { featured: false }) }))); };
export var CheckoutProductCard = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanCheckoutProductCard, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 300px;\n  .item-checkout {\n    display: inline;\n    .card {\n      pointer-events: none;\n    }\n  }\n"], ["\n  min-height: 300px;\n  .item-checkout {\n    display: inline;\n    .card {\n      pointer-events: none;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=checkoutProductCard.js.map